import gql from 'graphql-tag';
import { schema as orderSummarySchema } from '../../queries/getOrderSummary';

export default gql`
mutation updateStoreInfoForCart($storeId: String!, $items: [String]!){
  updateStoreInfoForCart(storeId: $storeId, items: $items) {
    ${orderSummarySchema}
  }
}
`;
